import { getInquiryContactDefaults } from '@/lib/inquiry-contact-defaults';
import { useMemo } from 'react';
import { useAuth } from './useAuth';
import { useProfile } from './useProfile';

export function useInquiryContactDefaults() {
  const { isAuthenticated, email } = useAuth();
  const { profile, firstName, lastName } = useProfile();

  const contactDefaults = useMemo(() => {
    if (!isAuthenticated) return null;

    return getInquiryContactDefaults({ email, firstName, lastName }, profile);
  }, [
    isAuthenticated,
    email,
    firstName,
    lastName,
    profile?.first_name,
    profile?.last_name,
    profile?.email_address,
    profile?.phone_mobile,
    profile?.phone_mobile_country_code,
    profile?.phone_work,
    profile?.phone_work_country_code,
    profile?.phone_other,
    profile?.phone_other_country_code,
    profile?.home_address?.country,
  ]);

  const defaultValuesCallback = useMemo(() => {
    if (!contactDefaults) return undefined;

    return () => contactDefaults;
  }, [contactDefaults]);

  return { defaultValuesCallback };
}
